/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TransactionIdData { 
    transactionDate?: string | null;
    amount?: number;
    description?: string | null;
    type?: string | null;
    accountId?: number;
    transactiontype?: string | null;
    userName?: string | null;
    accountNumber?: string | null;
    accountTypeName?: string | null;
    transactionNumber?: string | null;
    accountTransactionId?: number;
    accountTypeId?: number;
}

